/**
 * Related Products Carousel
 * Inicializa o BlazeSlider para o carousel de produtos relacionados
 */

(function() {
  'use strict';

  function initRelatedProductsCarousel(sectionId, autoplay, autoplaySpeed) {
    const carousel = document.querySelector(`[data-section-id="${sectionId}"] [data-carousel]`);
    if (!carousel) return;

    const blazeSlider = new BlazeSlider(carousel, {
      all: {
        slidesToShow: 4,
        slideGap: '40px',
        loop: true,
        enableAutoplay: autoplay,
        autoplayInterval: autoplaySpeed * 1000,
      },
      '(max-width: 1200px)': {
        slidesToShow: 3,
        slideGap: '30px',
      },
      '(max-width: 768px)': {
        slidesToShow: 1.3,
        slideGap: '20px',
      }
    });

    // Conectar arrows
    const prevBtn = document.querySelector(`[data-section-id="${sectionId}"] [data-carousel-prev]`);
    const nextBtn = document.querySelector(`[data-section-id="${sectionId}"] [data-carousel-next]`);

    if (prevBtn) {
      prevBtn.addEventListener('click', () => blazeSlider.prev());
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => blazeSlider.next());
    }

    // Atualizar dots
    const dots = document.querySelectorAll(`[data-section-id="${sectionId}"] .custom-product-carousel__dot`);

    blazeSlider.onSlide((pageIndex) => {
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === pageIndex);
      });
    });
  }

  // Inicializar quando o DOM estiver pronto e BlazeSlider estiver disponível
  function initAllCarousels() {
    if (typeof BlazeSlider === 'undefined') {
      // Tentar novamente após um pequeno delay se BlazeSlider ainda não estiver carregado
      setTimeout(initAllCarousels, 100);
      return;
    }

    // Buscar todas as seções de produtos relacionados na página
    const relatedCarousels = document.querySelectorAll('[data-section-id].section-related-products-carousel [data-carousel]');
    
    relatedCarousels.forEach(function(carouselElement) {
      const section = carouselElement.closest('[data-section-id]');
      if (!section) return;
      
      const sectionId = section.getAttribute('data-section-id');
      const autoplay = section.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed) || 5;
      
      initRelatedProductsCarousel(sectionId, autoplay, autoplaySpeed);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Exportar função para uso direto via data attributes
  window.initRelatedProductsCarousel = initRelatedProductsCarousel;
})();

